import { PartyPopper } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const LostFoundBadge = ({ listing }) => {
  const { t } = useLanguage();
  if (!listing?.lf_type) return null;
  if (listing.reunited_at) {
    return (
      <span data-testid={`lf-badge-${listing.id}`} className="inline-flex items-center gap-1 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-xs font-extrabold tracking-wider px-2.5 py-1 rounded-md shadow">
        <PartyPopper size={12} /> {t("lf_reunited")}
      </span>
    );
  }
  const lost = listing.lf_type === "lost";
  return (
    <span
      data-testid={`lf-badge-${listing.id}`}
      className={`inline-flex items-center gap-1 text-white text-xs font-extrabold tracking-wider px-2.5 py-1 rounded-md shadow ${lost ? "bg-red-600" : "bg-emerald-600"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse" />
      {lost ? t("lf_lost") : t("lf_found")}
    </span>
  );
};
